import { useEffect, useState } from 'react'
import uniq from 'lodash/uniq'
import { getImplementationProviders } from '../../services/implementation-items'

const useProvider = () => {
  const [providers, setProviders] = useState([])

  useEffect(() => {
    getImplementationProviders().then((data) => {
      if (data?.data && data?.data?.providers) {
        setProviders(uniq(data.data.providers.map((item) => item.provider).filter((item) => !!item)))
      }
    })
  }, [])

  return [providers]
}

export default useProvider
